import { useTranslation } from 'react-i18next';

const Bar = () => {
	const { t } = useTranslation();
	return (
		<section className='bg-white pb-16'>
			<div className='container py-8 bg-main flex flex-col items-center gap-6 md:flex-row md:justify-evenly rounded-lg frelative top-[-50px]'>
				<div className='card flex flex-col items-center'>
					<div className='images p-2 flex items-center justify-center w-20 h-20 text-white border-2 border-secondary bg-white rounded-full'>
						<img
							loading='lazy'
							src={'/images/postgraduate.png'}
							alt='research img'
							className='w-10/12'
						/>
					</div>
					<h3 className='text-white text-xl font-medium'>
						{t('postgraduate')}
					</h3>
				</div>

				<div className='card flex flex-col items-center'>
					<div className='images flex items-center justify-center p-2 w-20 h-20 text-white border-2 border-secondary bg-white rounded-full'>
						<img
							loading='lazy'
							src={'/images/engineer.png'}
							alt='reseacrh img w-full'
							className='w-10/12'
						/>
					</div>
					<h3 className='text-white text-xl font-medium'>{t('engineering')}</h3>
				</div>

				<div className='card flex flex-col items-center'>
					<div className='images flex items-center justify-center p-2 w-20 h-20 text-white border-2 border-secondary bg-white rounded-full'>
						<img
							loading='lazy'
							src={'/images/accounting.png'}
							alt='reseacrh img w-full'
							className='w-10/12'
						/>
					</div>
					<h3 className='text-white text-xl font-medium'> {t('accounting')}</h3>
				</div>
			</div>
		</section>
	);
};

export default Bar;
